import { render, staticRenderFns } from "./centricOS.vue?vue&type=template&id=04bbb0be&scoped=true"
import script from "./centricOS.vue?vue&type=script&lang=js"
export * from "./centricOS.vue?vue&type=script&lang=js"
import style0 from "./centricOS.vue?vue&type=style&index=0&id=04bbb0be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bbb0be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bbb0be')) {
      api.createRecord('04bbb0be', component.options)
    } else {
      api.reload('04bbb0be', component.options)
    }
    module.hot.accept("./centricOS.vue?vue&type=template&id=04bbb0be&scoped=true", function () {
      api.rerender('04bbb0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/centricOS.vue"
export default component.exports